import { render, staticRenderFns } from "./AddrPopup.vue?vue&type=template&id=0e04a49c&scoped=true"
import script from "./AddrPopup.vue?vue&type=script&lang=ts"
export * from "./AddrPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e04a49c",
  null
  
)

export default component.exports